/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrebidImportReferencesDto } from '../../models/prebid-import-references-dto';

export interface GetPrebidImportReferences$Params {
  'X-API-Version'?: string;
}

export function getPrebidImportReferences(http: HttpClient, rootUrl: string, params?: GetPrebidImportReferences$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidImportReferencesDto>> {
  const rb = new RequestBuilder(rootUrl, getPrebidImportReferences.PATH, 'get');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PrebidImportReferencesDto>;
    })
  );
}

getPrebidImportReferences.PATH = '/api/prebid-import/references';
